import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { openCalendly } from "@/lib/calendly";

const StickyCTA = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const heroHeight = window.innerHeight;
      setIsVisible(scrollY > heroHeight * 0.8);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gradient-to-t from-background via-background to-transparent md:hidden">
      <Button
        onClick={openCalendly}
        size="lg"
        className="w-full bg-accent hover:bg-accent/90 text-white text-base py-6 rounded-full shadow-accent animate-fade-in"
      >
        {t('hero.startWebsite')}
        <ArrowRight className="ml-2 h-5 w-5" />
      </Button>
    </div>
  );
};

export default StickyCTA;
